import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import Settings from './pages/Settings';
import PublicLive from './pages/PublicLive';
import Recordings from './pages/Recordings';
import Production from './pages/Production';
import Security from './pages/Security';
import GuestStudio from './pages/GuestStudio';
import UsageReports from './pages/UsageReports';
import ActivityLog from './pages/ActivityLog';
import ApiKeys from './pages/ApiKeys';
import IngestServers from './pages/IngestServers';

function Private({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}
function Public({ children }) {
  const { user } = useAuth();
  return !user ? children : <Navigate to="/dashboard" replace />;
}
function AdminRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/dashboard" replace />;
  return children;
}
function ManagerRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!['admin','manager'].includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login"          element={<Public><Auth /></Public>} />
      <Route path="/dashboard"      element={<Private><Dashboard /></Private>} />
      <Route path="/admin"          element={<AdminRoute><Admin /></AdminRoute>} />
      <Route path="/settings"       element={<Private><Settings /></Private>} />
      <Route path="/recordings"     element={<Private><Recordings /></Private>} />
      <Route path="/production"     element={<Private><Production /></Private>} />
      <Route path="/security"       element={<Private><Security /></Private>} />
      <Route path="/guest-studio"    element={<Private><GuestStudio /></Private>} />
      <Route path="/usage"          element={<ManagerRoute><UsageReports /></ManagerRoute>} />
      <Route path="/activity"       element={<ManagerRoute><ActivityLog /></ManagerRoute>} />
      <Route path="/api-keys"       element={<Private><ApiKeys /></Private>} />
      <Route path="/ingest-servers" element={<Private><IngestServers /></Private>} />
      <Route path="/live"           element={<PublicLive />} />
      <Route path="*"               element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

// Dynamically set favicon from station logo
function DynamicFavicon() {
  useEffect(() => {
    fetch('/api/settings/logo')
      .then(r => r.ok ? r.blob() : null)
      .then(blob => {
        if (!blob) return;
        const url = URL.createObjectURL(blob);
        const link = document.querySelector("link[rel='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.href = url;
        document.head.appendChild(link);
      }).catch(() => {});
  }, []);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <DynamicFavicon />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
